import React from 'react';
import ReactFlow, { useEdgesState, Background, MiniMap, Controls} from 'reactflow';
import 'reactflow/dist/style.css';
import './css/style.css';

import nodes from './nodes.js';
import edges from './edges.js';

import LMRTNode from './nodes/LMRTNode.js';

const nodeTypes = {
    LMRTNode: LMRTNode,
};

export default function App() {
    return (
        <div style={{ width: 'auto', height: '90vh' }}>
            <ReactFlow nodes={nodes} edges={edges} nodeTypes={nodeTypes} defaultViewport={{x: 0, y: 150, zoom: 0.9}} fitView={false} zoomOnScroll={false} panOnScroll={true}>
                <Controls />
                <MiniMap pannable zoomable />
                <Background color="#ccc" variant='dots'  />
            </ReactFlow>
        </div>
    );
}
